import { z } from "zod";

/**
 * Palette fixe des couleurs disponibles pour les labels client.
 * Les valeurs sont des identifiants stables pour permettre de faire évoluer la
 * charte graphique côté UI sans migration de données.
 */
export const CLIENT_LABEL_COLORS = [
  "slate",
  "red",
  "orange",
  "amber",
  "green",
  "teal",
  "blue",
  "indigo",
  "purple",
  "pink",
] as const;

export const ClientLabelPresetColorSchema = z.enum(CLIENT_LABEL_COLORS);
export const ClientLabelHexColorSchema = z
  .string()
  .regex(/^#([0-9a-fA-F]{6})$/, "Couleur hexadécimale invalide (#RRGGBB)");
export const ClientLabelColorSchema = z.union([
  ClientLabelPresetColorSchema,
  ClientLabelHexColorSchema,
]);
export type ClientLabelPresetColor = z.infer<typeof ClientLabelPresetColorSchema>;
export type ClientLabelColor = z.infer<typeof ClientLabelColorSchema>;

/** Création / mise à jour d'un label par le pro. */
export const ClientLabelSchema = z.object({
  name: z
    .string({ required_error: "Nom requis" })
    .trim()
    .min(1, "Nom requis")
    .max(40, "40 caractères max"),
  color: ClientLabelColorSchema.default("slate"),
  position: z.number().int().min(0).optional(),
});

export type ClientLabelDto = z.infer<typeof ClientLabelSchema>;

/**
 * Liste d'IDs de labels assignés à un client (utilisé pour PUT /clients/:id/labels).
 * Les doublons sont normalisés et l'ordre n'a pas d'importance.
 */
export const ClientLabelAssignmentSchema = z.object({
  labelIds: z.array(z.string().min(1)).default([]),
});

export type ClientLabelAssignmentDto = z.infer<
  typeof ClientLabelAssignmentSchema
>;
